import OnboardRoutes from "./onboard-route";
import AuthRoutes from "./auth-route";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { routerPath } from "./path";

const Navigation = () => {
	const isAuthorized = useSelector((state) => state.users.token);
	const isMembership = useSelector((state) => state.users.user?.is_membership);
	const navigate = useNavigate();
	const location = useLocation();
	const storedPath = localStorage.getItem("currentPath");
	useEffect(() => {
		if (
			storedPath &&
			storedPath != "/purchase-plan" &&
			storedPath !== location.pathname
		) {
			navigate(storedPath);
		} else {
			navigate(routerPath.Login);
		}
	}, []);

	useEffect(() => {
		if (storedPath != "/purchase-plan") {
			localStorage.setItem("currentPath", location.pathname);
		}
	}, [location.pathname]);

	return <>{isAuthorized ? <AuthRoutes /> : <OnboardRoutes />}</>;
};

export default Navigation;
